var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chat"}},[_c('PortalSidebar',[(_vm.isChatV2)?_c('ChatSocketComponent',{attrs:{"canBan":true,"room":_vm.buildRoomName({appointment_id: _vm.appointmentId, event_id: _vm.eventId}),"timezone":_vm.timezone}}):_c('ChatComponent',{attrs:{"url":_vm.url,"canBan":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }